import React, { useState } from "react";
import {
  Avatar,
  Box,
  Typography,
  Chip,
  IconButton,
  Badge,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import styles from "./AccordionForCouse.module.css";
import stylesForContent from "./Edufin.module.css";

interface AccordionForCourseProps {
  item?: any;
  index?: any;
}

const AccordionForCourse: React.FC<AccordionForCourseProps> = ({
  item,
  index,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        borderBottom: "1px solid #E5E7EB",
        p: 2,
        mb: 2,
        backgroundColor: "#fff",
        borderRadius: "8px",
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderBottom={open ? "1px solid rgba(0, 0, 0, 0.4)" : ""}
      >
        <div
          key={item.id}
          className={`${styles.notificationPageItem} ${
            item.status === "ACTIVE" ? styles.unread : ""
          }`}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", gap: "10px" }}>
              <div className={styles.sectionHeader}>{`Course ${
                index + 1
              }`}</div>
            </div>
          </div>
        </div>

        <Box display="flex" alignItems="center" gap={2}>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
      </Box>

      {open && (
        <Box
          mt={2}
          pl={5}
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div className={stylesForContent.savedContainerForCourses}>
            <div className={stylesForContent.savedInfoRow}>
              <div className={stylesForContent.savedInfoRowContent}>
                <div className={styles.subSectionKey}>Course Name :</div>
                <div className={styles.subSectionValue}>{item?.courseName}</div>
              </div>
              <div className={stylesForContent.savedInfoRowContent}>
                <div className={styles.subSectionKey}>Course Start Year :</div>
                <div className={styles.subSectionValue}>
                  {item?.courseStartYear}
                </div>
              </div>
            </div>
            <div className={stylesForContent.savedInfoRow}>
              <div className={stylesForContent.savedInfoRowContent}>
                <div className={styles.subSectionKey}>Duration : </div>
                <div className={styles.subSectionValue}>{item?.duration}</div>
              </div>
              <div className={stylesForContent.savedInfoRowContent}>
                <div className={styles.subSectionKey}>Number of Students :</div>
                <div className={styles.subSectionValue}>
                  {item?.noOfStudents}
                </div>
              </div>
            </div>
            <div className={stylesForContent.savedInfoRow}>
              <div className={stylesForContent.savedInfoRowContent}>
                <div className={styles.subSectionKey}>Tution Fee :</div>
                <div className={styles.subSectionValue}>{item?.tutionFees}</div>
              </div>
              <div className={stylesForContent.savedInfoRowContent}>
                <div className={styles.subSectionKey}>Transport Fee :</div>
                <div className={styles.subSectionValue}>
                  {item?.transportFees}
                </div>
              </div>
            </div>
            <div className={stylesForContent.savedInfoRow}>
              <div className={stylesForContent.savedInfoRowContent}>
                <div className={styles.subSectionKey}>Other Fee :</div>
                <div className={styles.subSectionValue}>{item?.otherFees}</div>
              </div>
              <div className={stylesForContent.savedInfoRowContent}>
                <div className={styles.subSectionKey}>Total Fee :</div>
                <div className={styles.subSectionValue}>{item?.totalFees}</div>
              </div>
            </div>
          </div>
        </Box>
      )}
    </Box>
  );
};

export default AccordionForCourse;
